module.exports = __webpack_public_path__ + "static/media/brand-image.2d3ff0f7.jpg";